import type { Product } from '../components/OpportunityPageTypes';
export type SalesPackage = { key: string; name: string; products: Product[] };
export function groupSalesPackages(products: Product[]): SalesPackage[] {
  const groups = new Map<string, SalesPackage>();
  products.forEach((product, index) => {
    const key = product.salesPackageId || `legacy:${index}:${product.productId}`;
    if (!groups.has(key)) groups.set(key, { key, name: product.salesPackageName || product.productName, products: [] });
    groups.get(key)!.products.push(product);
  });
  return [...groups.values()];
}
export function belongsToPackage(product: Product, representative: Product): boolean {
  return representative.salesPackageId ? product.salesPackageId === representative.salesPackageId
    : !product.salesPackageId && product.productId === representative.productId;
}
